/* @flow strict */

import moment from 'moment';

export const columns = [
  {
    selector: 'first_name',
    name: 'First Name',
    sortable: true
  },
  {
    selector: 'last_name',
    name: 'Last Name',
    sortable: true
  },
  {
    selector: 'attendance_event_count',
    name: 'Attendance Count',
    sortable: true,
    cell: (row: {}): React.Element => {
      if (row.attendance_event_count === 1) {
        return 'First event!';
      }

      return row.attendance_event_count;
    }
  },
  {
    selector: 'last_participate_time_utc',
    name: 'Date Purchased',
    sortable: true,
    cell: (row: {}): React.Element => {
      try {
        const date = moment(row.last_participate_time_utc).format(
          'MM/DD/YY hh:mm a z'
        );

        return date;
      } catch (e) {
        console.log(e);
        return '';
      }
    }
  },
  {
    selector: 'email_address',
    name: 'Email',
    sortable: true
  },
  {
    selector: 'phone_number',
    name: 'Phone',
    sortable: true
  },
  {
    selector: 'zip_code',
    name: 'Zip Code',
    sortable: true
  }
];

// export const data = [
//   {
//     fname: 'db test',
//     lname: 'db test',
//     attendance_count: 'db test',
//     data_purchased: 'db test',
//     email: 'db test',
//     phone: 'db test',
//     zip_code: 'db test'
//   },
//   {
//     fname: 'db test 2',
//     lname: 'db test 2',
//     attendance_count: 'db test 2',
//     data_purchased: 'db test 2',
//     email: 'db test 2',
//     phone: 'db test 2',
//     zip_code: 'db test 2'
//   }
// ];
